import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class MinedDamageView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     */
    constructor(parentId, damage) {
        super(parentId, parentId + '_mined');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedDamageMultiplier = new BigNum(0);
        /**
         * @type {string}
         */
        this.bonusString = null;

        /**
         * @type {HTMLElement}
         */
        this.body = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        const container = Page.createElement('div', parentElement, this.getElementId(), 'mine-damage-panel-main-section');

        const headerElement = Page.createElement('div', container, null, 'mine-damage-panel-section-header');
        headerElement.innerHTML = 'Mined';

        this.body = Page.createElement('div', container, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const damageMultiplier = this.damage.minedDamageMultiplier;

        /////////////////////////////////////
        // Damage Bonus
        /////////////////////////////////////

        if (!this.bonusString || !damageMultiplier.equals(this.displayedDamageMultiplier)) {
            this.displayedDamageMultiplier.copy(damageMultiplier);
            this.bonusString = NumberFormatter.formatBigNum(damageMultiplier);
            this.body.innerHTML = this.bonusString;
        }

        super.updateViewContents();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}